export default function ClientProjects() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-2xl rounded-xl border bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold">Espace projets (client)</h1>
        <p className="mt-2 text-sm text-gray-600">
          Cette page sert à valider la protection de route par rôle (CLIENT).
          Elle pourra être remplacée par l&apos;interface de gestion des projets.
        </p>
      </div>
    </div>
  );
}

